import type { Resource } from '../../';
export const forms_error_generic_invalidValue: Resource = {"default":"Invalid {name}"};
